import { OrderDto } from '@api/client';
import { isEmpty } from 'lodash';
import { isDefined } from '@stillmandigital/common';
import { OrderStatusEnum } from '@shared/enums/order-status';

export interface OrderNotification {
  message: string;
  params?: { [key: string]: unknown };
}

export function getOrderNotifications(
  state: OrderDto[],
  update: OrderDto[],
): OrderNotification[] {
  if (isEmpty(update) || isEmpty(state)) {
    return [];
  }

  const notifications: OrderNotification[] = [];

  update.forEach(order => {
    const prevState = state.find(o => o.orderId === order.orderId)?.status;

    if (prevState === order.status) {
      return;
    }
    const { message, params } = getNotificationMessage(order);

    if (isDefined(message)) {
      notifications.push({ message, params });
    }
  });

  return notifications;
}

function getNotificationMessage(order: OrderDto): {
  message?: string;
  params?: { [key: string]: unknown };
} {
  const action = getActionName(order.status);

  if (!isDefined(action)) {
    return { message: undefined };
  }

  const { side, pairName: pair } = order;

  return { message: `ORDERS.NOTIFICATION.${action}`, params: { side, pair } };
}

function getActionName(status: OrderStatusEnum): string | undefined {
  switch (status) {
    case 'CANCELED':
      return `CANCELLED`;
    default:
      return status;
  }
}

export const mapOrders = (order: OrderDto) => ({
  ...order,
  requestedQty: order.requestedQuantityInQuoteAsset ?? order.quantity,
  requestedAsset: order.pairName.split('/')[order.requestedQuantityInQuoteAsset ? 1 : 0],
});
